module.exports = __webpack_public_path__ + "static/media/precision.f831241d.svg";